import React from "react";

import { Separator } from "@swa-ui/core";
import { Currency } from "@swa-ui/currency";
import { TextContent } from "@swa-ui/placements";

const renderOfferDetails = (offerDetails, styles) => {
  const { delimiter, offers } = offerDetails;
  const offersContent = [];

  for (let i = 0; i < offers.length; i += 1) {
    offersContent.push(renderOffer(offers[i], styles, i));

    if (i !== offers.length - 1) {
      offersContent.push(renderSeparator(delimiter, styles, i));
    }
  }

  return offersContent;
};

function renderOffer(offer, styles, i) {
  const { bottomCaption, topCaption, value } = offer;

  return (
    <div className={styles.offerContent} key={`offer-${i}`}>
      {topCaption?.value && <TextContent {...topCaption} />}
      {value && <Currency {...getCurrencyProps(value)} />}
      {bottomCaption?.value && <TextContent {...bottomCaption} />}
    </div>
  );
}

function getCurrencyProps(currencyType) {
  return {
    ...currencyType,
    amount: currencyType.value,
  };
}

function renderSeparator(delimiter, styles, i) {
  const { lineSeparator, text: delimiterText } = delimiter;

  return (
    <div className={styles.delimiter} key={`delimiter-${i}`}>
      <Separator {...getSeparatorProps(lineSeparator, styles)} />
      <div {...getStyleProps(delimiterText)}>{delimiterText.value}</div>
      <Separator {...getSeparatorProps(lineSeparator, styles)} />
    </div>
  );
}

function getSeparatorProps(lineSeparator, styles) {
  const { color, fontWeight } = lineSeparator;

  return {
    className: styles.separator,
    color,
    orientation: "vertical",
    weight: fontWeight,
  };
}

function getStyleProps(textType) {
  const { color, fontSize, fontWeight } = textType || {};

  return {
    style: {
      color,
      fontSize,
      fontWeight,
    },
  };
}

export { renderOfferDetails };
